export const feedBack = {
  "EN": {
    "title": "Please select a feedback type",
    "feedBackCates": [
      "Unable to download",
      "Unable to install",
      "Old version",
      "Malicious charge",
      "Virus",
      "Copyright",
      "Sexual content",
      "Other"
    ],
    "submitTxt": "Submit",
    "submitTip": "Thanks for your feedback"
  },
  "am_ET": {
    "title": "እባኮን የግብረመልስ አይነት ይምረጡ",
    "feedBackCates": [
      "ለማውረድ አልተሳካም",
      "ለመጫን አልተሳካም",
      "የድሮ ስሪት",
      "ጎጂ ክፍያ",
      "ቫይረስ",
      "የቅጂ መብት",
      "ወሲባዊ ይዘት",
      "ሌላ"
    ],
    "submitTxt": "ያስገቡ",
    "submitTip": "ለምላሾ እናመሰግናለን"
  },
  "ar_EG": {
    "title": "يرجى اختيار نوع ردود الفعل",
    "feedBackCates": [
      "غير قادر على التحميل",
      "غير قادر على التثبيت",
      "نسخة قديمة",
      "رسوم عالية",
      "فيروس",
      "حقوق الملكية",
      "محتوى جنسي",
      "أخرى"
    ],
    "submitTxt": "إرسال",
    "submitTip": "شكرًا على تقييمك"
  },
  "bn_BD": {
    "title": "অনুগ্রহ করে প্রতিক্রিয়ার একটি ধরণ নির্বাচন করুন",
    "feedBackCates": [
      "ডাউনলোড করতে ব্যর্থ হয়েছে",
      "ইনস্টল করতে অক্ষম",
      "পুরনো সংস্করণ",
      "ম্যালিসিয়াস চার্জ",
      "ভাইরাস",
      "কপিরাইট",
      "যৌন সামগ্রী",
      "অন্যান্য"
    ],
    "submitTxt": "জমা দিন",
    "submitTip": "আপনার প্রতিক্রিয়ার জন্য ধন্যবাদ"
  },
  "es_US": {
    "title": "Seleccione un tipo de comentario",
    "feedBackCates": [
      "No se puede descargar",
      "No se puede instalar",
      "Versión antigua",
      "Cobro malicioso",
      "Virus",
      "Derechos de autor",
      "Contenido sexual",
      "Otro"
    ],
    "submitTxt": "Enviar",
    "submitTip": "Gracias por tu comentario"
  },
  "fa_IR": {
    "title": "لطفاً یک نوع بازخورد را انتخاب کنید",
    "feedBackCates": [
      "دانلود امکان‌پذیر نبود",
      "نصب نمی شود",
      "نسخه قدیمی",
      "هزینه مخرب",
      "ویروس",
      "حق نسخه‌برداری",
      "محتوای جنسی",
      "دیگر"
    ],
    "submitTxt": "ارسال",
    "submitTip": "تشکر از شما برای بازخوردتان"
  },
  "fr_FR": {
    "title": "Veuillez sélectionner un type de commentaire",
    "feedBackCates": [
      "Impossible de télécharger",
      "Impossible d'installer",
      "Ancienne version",
      "Arnaque",
      "Virus",
      "Droits d'auteur",
      "Contenu sexuel",
      "Autres"
    ],
    "submitTxt": "Soumettre",
    "submitTip": "Merci pour vos commentaires"
  },
  "gu_IN": {
    "title": "કૃપા કરીને પ્રતિસાદનો પ્રકાર પસંદ કરો",
    "feedBackCates": [
      "ડાઉનલોડ કરવામાં અસમર્થ",
      "સ્થાપિત કરવામાં અસમર્થ",
      "જુનુ સંસ્કરણ",
      "દૂષિત ચાર્જ",
      "વાયરસ",
      "કોપિરાઇટ",
      "જાતીય સામગ્રી",
      "અન્ય"
    ],
    "submitTxt": "રજુ કરો",
    "submitTip": "તમારા પ્રતિસાદ માટે આભાર"
  },
  "hi_IN": {
    "title": "कृपया फ़ीडबैक प्रकार चुनें",
    "feedBackCates": [
      "डाउनलोड करने में असमर्थ",
      "इन्स्टॉल करने में असमर्थ",
      "पुराना संस्करण",
      "दुर्भावनापूर्ण चार्ज",
      "वायरस",
      "कॉपीराइट",
      "कामुक सामग्री",
      "अन्य"
    ],
    "submitTxt": "सबमिट करें",
    "submitTip": "प्रतिक्रिया के लिए धन्यवाद"
  },
  "ha_NG": {
    "title": "Zaɓi wani martani mana",
    "feedBackCates": [
      "An gagara sauke",
      "An gagara sakawa",
      "Tsohuwar siga",
      "Cajin mugunta",
      "Ƙwayar cuta",
      "Haƙƙin mallaka",
      "Game da abubuwan jima\\'i",
      "Saura"
    ],
    "submitTxt": "Gabatar",
    "submitTip": "Muna godiya da martaninka"
  },
  "in_ID": {
    "title": "Pilih jenis umpan balik",
    "feedBackCates": [
      "Tidak dapat mengunduh",
      "Tidak dapat menginstal",
      "Versi lama",
      "Tuduhan jahat",
      "Virus",
      "Hak Cipta",
      "Konten seksual",
      "Lainnya"
    ],
    "submitTxt": "Kirim",
    "submitTip": "Terima kasih atas tanggapan Anda"
  },
  "kk_KZ": {
    "title": "Кері байланыс түрін таңдаңыз",
    "feedBackCates": [
      "Жүктеп алу мүмкін емес",
      "Орнату мүмкін емес",
      "Ескі нұсқа",
      "Зиянды қуаттау",
      "Вирус",
      "Авторлық құқықтар",
      "Порнографиялық контент",
      "Басқа"
    ],
    "submitTxt": "Жіберу",
    "submitTip": "Берген пікіріңізге рақмет"
  },
  "km_KH": {
    "title": "សូមជ្រើសរើសប្រភេទមតិប្រតិកម្មមួយ",
    "feedBackCates": [
      "មិនអាចទាញយកបាន",
      "មិនអាចដំឡើងបាន",
      "កំណែចាស់",
      "សាកថ្មមិនបានល្អ",
      "វីរុស",
      "រក្សាសិទ្ធិ",
      "ខ្លឹមសារ​ផ្លូវភេទ​",
      "ផ្សេងៗ"
    ],
    "submitTxt": "ដាក់​ស្នើ",
    "submitTip": "សូមអរគុណចំពោះមតិយោបល់របស់អ្នក"
  },
  "kn_IN": {
    "title": "ದಯವಿಟ್ಟು ಒಂದು ಪ್ರತಿಕ್ರಿಯೆಯ ವಿಧವನ್ನು ಆರಿಸಿ!",
    "feedBackCates": [
      "ಡೌನ್‍ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
      "ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ",
      "ಹಳೆಯ ಆವೃತ್ತಿ",
      "ದುರುದ್ದೇಶಪೂರಿತ ಶುಲ್ಕ",
      "ವೈರಸ್",
      "ಕೃತಿಸ್ವಾಮ್ಯ",
      "ಲೈಂಗಿಕ ಕಂಟೆಂಟ್",
      "ಇತರ"
    ],
    "submitTxt": "ಸಲ್ಲಿಸಿ",
    "submitTip": "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಧನ್ಯವಾದಗಳು"
  },
  "lo_LA": {
    "title": "ກະລຸນາເລືອກປະເພດຄຳຕິຊົມ",
    "feedBackCates": [
      "ບໍ່ສາມາດດາວໂຫຼດໄດ້",
      "ບໍ່ສາມາດຕິດຕັ້ງໄດ້",
      "ລຸ້ນເກົ່າ",
      "ຂໍ້ຫາການລະບຸເວັບໄຊທີ່ເປັນອັນຕະລາຍ",
      "ໄວຣັສ",
      "ສະຫງວນລິຂະສິດ",
      "​ເນື້ອ​ຫາ​ສື່​ທາງ​ເພດ",
      "ອື່ນໆ"
    ],
    "submitTxt": "ສົ່ງຂໍ້ມູນ",
    "submitTip": "ຂອບໃຈສໍາລັບຄໍາເຫັນຂອງທ່ານ"
  },
  "mr_IN": {
    "title": "कृपया अभिप्राय प्रकार निवडा",
    "feedBackCates": [
      "डाउनलोड करण्यात अक्षम",
      "स्‍थापित करण्यात अक्षम",
      "जुनी आवृत्ती",
      "मत्सरी चार्ज",
      "व्हायरस",
      "कॉपीराइट",
      "लैंगिक मजकूर",
      "अन्य"
    ],
    "submitTxt": "सबमिट करा",
    "submitTip": "आपल्या अभिप्रायाबद्दल धन्यवाद"
  },
  "ms_MY": {
    "title": "Sila pilih jenis maklum balas",
    "feedBackCates": [
      "Tidak dapat memuat turun",
      "Tidak dapat memasang",
      "Versi lama",
      "Caj berniat jahat",
      "Virus",
      "Hak cipta",
      "Kandungan seksual",
      "Lain-lain"
    ],
    "submitTxt": "Serah",
    "submitTip": "Terima kasih atas maklum balas anda"
  },
  "my_ZG": {
    "title": "ေက်းဇူးျပဳ၍ တုံ႔ျပန္ခ်က္အမ်ိဳးအစားကို ေ႐ြးပါ",
    "feedBackCates": [
      "ေဒါင္းလုဒ္လုပ္၍မရပါ",
      "ထည့္သြင္းတပ္ဆင္၍မရပါ",
      "ဗားရွင္းအေဟာင္း",
      "ႀကံဖန္လုပ္ေသာ အခေၾကးေငြ",
      "ဗုိင္းရပ္စ္",
      "မူပိုင္ခြင့္",
      "အျခား"
    ],
    "submitTxt": "တင္ျပရန္",
    "submitTip": "သင့္တုံ႔ျပန္ခ်က္အတြက္ ေက်းဇူးတင္ပါသည္"
  },
  "ne_NP": {
    "title": "कृपया प्रतिक्रियाको प्रकार छान्नुहोस्",
    "feedBackCates": [
      "डाउनलोड गर्न सकिएन",
      "इन्स्टल गर्न असमर्थ",
      "पुरानो संस्करण",
      "मालिसियस चार्ज",
      "भाइरस",
      "प्रतिलिपि अधिकार",
      "यौनजन्य सामग्री",
      "अन्य"
    ],
    "submitTxt": "पेस गर्नुहोस्",
    "submitTip": "तपाईंको प्रतिक्रियाको लागि धन्यवाद"
  },
  "om_ET": {
    "title": "Maaloo gosa dubdeebii filadhu",
    "feedBackCates": [
      "Buusuu hin dandeenye",
      "Fe'uu hin dandeenye",
      "Veshinii Dullomaa",
      "Gatii haxxee",
      "Vaayirasii",
      "Mirga garagalcha",
      "Qabiyyee wal qunnamtii",
      "Kan biraa"
    ],
    "submitTxt": "Ergi",
    "submitTip": "Dubdeebii keetiif galatoomi"
  },
  "pa_IN": {
    "title": "ਕਿਰਪਾ ਕਰਕੇ ਫੀਡਬੈਕ ਦੀ ਕਿਸਮ ਚੁਣੋ",
    "feedBackCates": [
      "ਡਾਊਨਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
      "ਇੰਸਟਾਲ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
      "ਪੁਰਾਣਾ ਵਰਜ਼ਨ",
      "ਖਤਰਨਾਕ ਚਾਰਜ",
      "ਵਾਈਰਸ",
      "ਕਾਪੀਰਾਈਟ",
      "ਜਿਨਸੀ ਸਮੱਗਰੀ",
      "ਹੋਰ"
    ],
    "submitTxt": "ਭੇਜੋ",
    "submitTip": "ਤੁਹਾਡੀ ਫੀਡਬੈਕ ਲਈ ਧੰਨਵਾਦ"
  },
  "pt_PT": {
    "title": "Por favor seleccione um tipo de feedback",
    "feedBackCates": [
      "Incapaz de download",
      "Não é possível instalar",
      "Versão antiga",
      "Cobrança maliciosa",
      "Vírus",
      "Direito autoral",
      "Conteúdo sexual",
      "Outros"
    ],
    "submitTxt": "Submeter",
    "submitTip": "Obrigado pelo seu feedback"
  },
  "ru_RU": {
    "title": "Выберите тип отзыва",
    "feedBackCates": [
      "Не удалось загрузить",
      "Невозможно установить",
      "Старая версия",
      "Злонамеренные обвинения",
      "Вирус",
      "Авторское право",
      "Сексуальный контент",
      "Другое"
    ],
    "submitTxt": "Подтвердить",
    "submitTip": "Спасибо за ваш отзыв"
  },
  "si_LK": {
    "title": "කරුණාකර ප්‍රතිපෝෂණ වර්ගයක් තෝරන්න",
    "feedBackCates": [
      "බාගත කළ නොහැක",
      "ස්ථාපනය කරන්නට නොහැක",
      "පැරණි අනුවාදය",
      "ද්වේෂ සහගත ගාස්තුව",
      "වෛරස්",
      "ප්‍රකාශන හිමිකම",
      "ලිංගික අන්තර්ගතය",
      "වෙනත්"
    ],
    "submitTxt": "යොමු කරන්න",
    "submitTip": "ඔබේ අදහස්වලට ස්තූතියි"
  },
  "sw_TZ": {
    "title": "Tafadhali chagua aina ya maoni",
    "feedBackCates": [
      "Haiwezi kupakua",
      "Imeshindwa kusakinisha",
      "Toleo la zamani",
      "Chaji bovu",
      "Virusi",
      "Hakimiliki",
      "Maudhui ya ngono",
      "Nyingine"
    ],
    "submitTxt": "Wasilisha",
    "submitTip": "Asante kwa maoni yako"
  },
  "ta_IN": {
    "title": "ஒரு பின்னூட்ட வகையைத் தேர்ந்தெடுங்கள்",
    "feedBackCates": [
      "பதிவிறக்க இயலவில்லை",
      "நிறுவ முடியவில்லை",
      "பழைய பதிப்பு",
      "தீங்கிழைக்கும் சார்ஜ்",
      "வைரஸ்",
      "பதிப்புரிமை",
      "பாலியல் உள்ளடக்கம்",
      "மற்றவை"
    ],
    "submitTxt": "சமர்ப்பி",
    "submitTip": "உங்கள் பின்னூட்டத்திற்கு நன்றி"
  },
  "te_IN": {
    "title": "దయచేసి ఒక ఫీడ్‌బ్యాక్ రకాన్ని ఎంచుకోండి!",
    "feedBackCates": [
      "డౌన్‌లోడ్ చేయలేకపోయింది",
      "ఇన్‌స్టాల్ చేయలేకపోయింది",
      "పాత వెర్షన్",
      "మోసపూరితమైన ఆరోపణ",
      "వైరస్",
      "కాపీరైట్",
      "లైంగిక కంటెంట్",
      "ఇతర"
    ],
    "submitTxt": "సమర్పించు",
    "submitTip": "మీ ఫీడ్‌బ్యాక్‌కు ధన్యవాదాలు"
  },
  "th_TH": {
    "title": "โปรดเลือกประเภทของข้อเสนอแนะ",
    "feedBackCates": [
      "ไม่สามารถดาวน์โหลดได้",
      "ไม่สามารถติดตั้งได้",
      "เวอร์ชันเก่า",
      "ข้อหา",
      "ไวรัส",
      "ลิขสิทธิ์",
      "เนื้อหาทางเพศ",
      "อื่นๆ"
    ],
    "submitTxt": "ส่ง",
    "submitTip": "ขอบคุณสำหรับคำติชมของคุณ"
  },
  "ti_ET": {
    "title": "በይዘኦም ናይ ምላሽ ዓይነት ይምረፁ",
    "feedBackCates": [
      "ምዉራድ ኣይተኽኣለን",
      "ምፅዓን ኣይተኽኣለን",
      "ዝነበረ ስርሒት",
      "ጎዳእቲ ኽፍሊታት",
      "ቫይረስ",
      "መሰል ቕዳሕ",
      "ፆታዊ ትሕዝቶ",
      "ኻሊእ"
    ],
    "submitTxt": "ኣእትዉ",
    "submitTip": "ንምላሾም ነመስን"
  },
  "tl_PH": {
    "title": "Piliin ang uri ng feedback",
    "feedBackCates": [
      "Hindi na-download",
      "Hindi na-install",
      "Lumang Bersyon",
      "Hindi tamang pagsingil",
      "Virus",
      "Copyright",
      "Seksuwal an nilalaman",
      "Iba pa"
    ],
    "submitTxt": "Isumite",
    "submitTip": "Salamat sa iyong feedback"
  },
  "tr_TR": {
    "title": "Lütfen bir geri bildirim türü seçin",
    "feedBackCates": [
      "İndirilemiyor",
      "Yüklenemiyor",
      "Eski sürüm",
      "Kötü amaçlı ücret",
      "Virüs",
      "Telif hakkı",
      "\"Cinsel içerik\"",
      "Diğer"
    ],
    "submitTxt": "Gönder",
    "submitTip": "Geri bildiriminiz için teşekkürler"
  },
  "uk_UA": {
    "title": "Виберіть тип зворотного зв'язку",
    "feedBackCates": [
      "Неможливо завантажити",
      "Неможливо встановити",
      "Стара версія",
      "Зловмисне звинувачення",
      "Вірус",
      "Авторське право",
      "Сексуальні сцени",
      "Інше"
    ],
    "submitTxt": "Надіслати",
    "submitTip": "Дякуємо за відгук"
  },
  "ur_PK": {
    "title": "براہ کرم تاثرات کی قسم منتخب کریں",
    "feedBackCates": [
      "ڈاؤن لوڈ کرنے سے قاصر",
      "انسٹال کرنے سے قاصر",
      "پرانا ورژن",
      "بدنیتی پر مبنی الزام",
      "وائرس",
      "کاپی رائٹ",
      "فحش مواد",
      "دیگر"
    ],
    "submitTxt": "بھجوائیں",
    "submitTip": "آپ کی رائے کا شکریہ"
  },
  "vi_VN": {
    "title": "Vui lòng chọn loại phản hồi",
    "feedBackCates": [
      "Không thể tải về",
      "Không thể cài đặt",
      "Phiên bản cũ",
      "Tính phí lừa đảo",
      "Vi rút",
      "Bản quyền",
      "Nội dung tình dục",
      "Khác"
    ],
    "submitTxt": "Gửi đi",
    "submitTip": "Cảm ơn phản hồi của bạn"
  },
  "ckb_IQ": {
    "title": "تکایە جۆری فیدباک هەڵبژێرە!",
    "feedBackCates": [
      "داگرتن مومکین نیە",
      "دامەزراندن مومکین نیە",
      "ڤێرژنی کۆن",
      "تۆمەتی بەدکاری",
      "ڤایرۆس",
      "کۆپی ڕایت",
      "ناوەرۆکی سێکسی",
      "ئەوانی دیکە"
    ],
    "submitTxt": "ناردن",
    "submitTip": "سپاس بۆ هەڵسەنگاندنەکەت"
  },
  "my_MM": {
    "title": "တုံ့ပြန်ချက် အမျိုးအစားတစ်ခု ရွေးပေးပါ",
    "feedBackCates": [
      "ဒေါင်းလုဒ် လုပ်၍မရပါ",
      "အင်စတော လုပ်၍မရပါ",
      "ဗားရှင်းဟောင်း",
      "မလိုလားဖွယ် အားသွင်းမှု",
      "ဗိုင်းရပ်စ်",
      "မူပိုင်ခွင့်",
      "လိင်မှုဆိုင်ရာ အကြောင်းအရာ",
      "အခြား"
    ],
    "submitTxt": "တင်သွင်းသည်",
    "submitTip": "သင့်တုံ့ပြန်ချက်အတွက် ကျေးဇူးတင်ပါသည်"
  },
  "my_Qaag": {
    "title": "ေက်းဇူးျပဳ၍ တုံ႔ျပန္ခ်က္အမ်ိဳးအစားကို ေ႐ြးပါ",
    "feedBackCates": [
      "ေဒါင္းလုဒ္လုပ္၍မရပါ",
      "ထည့္သြင္းမရႏုိင္ပါ",
      "ဗားရွင္းအေဟာင္း",
      "ႀကံဖန္လုပ္ေသာ အခေၾကးေငြ",
      "ဗုိင္းရပ္စ္",
      "မူပိုင္ခြင့္",
      "လိင္ကိစၥႏွင့္ ပတ္သက္သည့္ အေၾကာင္းအရာ",
      "အျခား"
    ],
    "submitTxt": "တင္ျပရန္",
    "submitTip": "သင့္တုံ႔ျပန္ခ်က္အတြက္ ေက်းဇူးတင္ပါသည္"
  },
  "pt_BR": {
    "title": "Selecione um tipo de feedback!",
    "feedBackCates": [
      "Incapaz de realizar para download",
      "Incapaz de instalar",
      "Versão antiga",
      "Cobrança maliciosa",
      "Vírus",
      "Direitos autorais",
      "Conteúdo sexual",
      "Outros"
    ],
    "submitTxt": "Submeter",
    "submitTip": "Obrigado pelo seu feedback"
  },
  "iw_IL": {
    "title": "בחר סוג משוב",
    "feedBackCates": [
      "לא ניתן להוריד",
      "לא ניתן להתקין",
      "גרסה ישנה",
      "חיוב זדוני",
      "וִירוּס",
      "זכויות יוצרים",
      "תוכן מיני",
      "אחרת"
    ],
    "submitTxt": "שלח",
    "submitTip": "תודה על המשוב שלך"
  },
  "ml_IN": {
    "title": "ഒരു ഫീഡ്ബാക്ക് തരം തിരഞ്ഞെടുക്കുക",
    "feedBackCates": [
      "ഡൗൺലോഡ് ചെയ്യാൻ കഴിയുന്നില്ല",
      "ഇൻസ്റ്റാൾ ചെയ്യാൻ കഴിയുന്നില്ല",
      "പഴയ പതിപ്പ്",
      "ക്ഷുദ്രകരമായ ചാർജ്ജ്",
      "വൈറസ്",
      "പകർപ്പവകാശം",
      "അശ്ലീല ഉള്ളടക്കം",
      "മറ്റുള്ളവർ"
    ],
    "submitTxt": "സമർപ്പിക്കുക",
    "submitTip": "നിങ്ങളുടെ അഭിപ്രായത്തിന് നന്ദി"
  },
  "as_IN": {
    "title": "অনুগ্ৰহ কৰি মতামত এটা প্ৰকাৰ বাছনি কৰক!",
    "feedBackCates": [
      "ডাউনলোড কৰিবলৈ অক্ষম",
      "ইনষ্টল কৰিবলৈ অক্ষম",
      "পুৰণা সংস্কৰণ",
      "ক্ষতিকাৰক অভিযোগ",
      "ভাইৰাছ",
      "কপিৰাইট",
      "যৌনগন্ধী সমল",
      "অন্যান্য"
    ],
    "submitTxt": "দাখিল কৰক",
    "submitTip": "আপোনাৰ মতামতৰ বাবে ধন্যবাদ"
  },
  "ks_IN": {
    "title": "میٛہربٲنی کٔرِتھۍ کٔرِو اَکھ رائے قسم منتخب",
    "feedBackCates": [
      "ڈاؤن لوڈ کرنَس مَنٛز ناکام",
      "ناکام انسٹال کرنَس",
      "پُرون ورژن",
      "میلیشس چارج",
      "وائرس",
      "حقِ اشاعت",
      "جنسی مواد",
      "باقٕے"
    ],
    "submitTxt": "درج کریو",
    "submitTip": "تُہندن خیلاتن ہند شکریہ"
  },
  "or_IN": {
    "title": "ଦୟାକରି ଏକ ମତାମତ ପ୍ରକାର ଚୟନ କରନ୍ତୁ!",
    "feedBackCates": [
      "ଡାଉନ୍‌ଲୋଡ୍‌ କରିବାକୁ ଅକ୍ଷମ",
      "ସଂସ୍ଥାପନ କରିବାକୁ ଅକ୍ଷମ",
      "ପୁରୁଣା ସଂସ୍କରଣ",
      "ମାଲାସିୟସ୍‌ ଚାର୍ଜ",
      "ଭାଇରସ୍",
      "କପିରାଇଟ୍",
      "ଯୌନ ସମ୍ପର୍କିତ ବିଷୟବସ୍ତୁ",
      "ଅନ୍ୟ"
    ],
    "submitTxt": "ଦାଖଲ କରନ୍ତୁ",
    "submitTip": "ଆପଣଙ୍କ ମତାମତ ପାଇଁ ଧନ୍ୟବାଦ |"
  },
  "cs_CZ": {
    "title": "Vyberte typ zpětné vazby",
    "feedBackCates": [
      "Nelze stáhnout",
      "Nelze instalovat",
      "Stará verze",
      "Škodlivý poplatek",
      "Virus",
      "Autorská práva",
      "Sexuální obsah",
      "Ostatní"
    ],
    "submitTxt": "Odeslat",
    "submitTip": "Děkujeme za zpětnou vazbu"
  },
  "sr_RS": {
    "title": "Izaberite vrstu povratne informacije!",
    "feedBackCates": [
      "Nije moguće preuzeti",
      "Nije moguće instalirati",
      "Stara verzija",
      "Zlonamerna optužba",
      "Virus",
      "Autorska prava",
      "Drugo"
    ],
    "submitTxt": "Podnesi",
    "submitTip": "Hvala vam na oceni kvaliteta"
  },
  "bs_BA": {
    "title": "Odaberite vrstu povratne informacije",
    "feedBackCates": [
      "Nije moguće preuzeti",
      "Nije moguće instalirati",
      "Stara verzija",
      "Zlonamjerna optužba",
      "Virus",
      "Autorska prava",
      "Drugo"
    ],
    "submitTxt": "Pošalji",
    "submitTip": "Hvala na vašoj povratnoj informaciji"
  },
  "sr_ME": {
    "title": "Odaberite vrstu povratnih informacija",
    "feedBackCates": [
      "Nije moguće preuzeti",
      "Nije moguće instalirati",
      "Stara verzija",
      "Zlonamjerna naplata",
      "Virus",
      "Autorsko pravo",
      "Drugo"
    ],
    "submitTxt": "Podnesi",
    "submitTip": "Hvala vam na povratnim informacijama"
  },
  "sq_AL": {
    "title": "Zgjidh një lloj reagimi",
    "feedBackCates": [
      "Nuk mund të shkarkojë",
      "Nuk mund të instalojë",
      "Version i vjetër",
      "Karikim keqdashës",
      "Virus",
      "E drejta e autorit",
      "Përmbajtje seksuale",
      "Tjetër"
    ],
    "submitTxt": "Dorëzo",
    "submitTip": "Faleminderit për reagimin tënd"
  },
  "mk_MK": {
    "title": "Изберете тип повратни информации",
    "feedBackCates": [
      "Не може да се преземе",
      "Не може да се инсталира",
      "Стара верзија",
      "Злонамерна наплата",
      "Вирус",
      "Авторски права",
      "Сексуална содржина",
      "Останато"
    ],
    "submitTxt": "Поднеси",
    "submitTip": "Благодариме за вашите повратни информации"
  },
  "de_DE": {
    "title": "Bitte einen Feedback-Typ wählen",
    "feedBackCates": [
      "Download nicht möglich",
      "Installieren nicht möglich",
      "Alte Version",
      "Böswillige Gebühr",
      "Virus",
      "Copyright",
      "Sexueller Inhalt",
      "Sonstiges"
    ],
    "submitTxt": "Abschicken",
    "submitTip": "Vielen Dank für dein Feedback"
  },
  "it_IT": {
    "title": "Seleziona un tipo di feedback",
    "feedBackCates": [
      "Impossibile eseguire il download",
      "Impossibile eseguire l'installazione",
      "Versione obsoleta",
      "Carica dannosa",
      "Virus",
      "Copyright",
      "Contenuti sessuali",
      "Altro"
    ],
    "submitTxt": "Invia",
    "submitTip": "Grazie per la tua opinione"
  },
  "el_GR": {
    "title": "Επιλέξτε τύπο σχολίων",
    "feedBackCates": [
      "Αδυναμία λήψης",
      "Αδυναμία εγκατάστασης",
      "Παλιά έκδοση",
      "Κακόβουλη χρέωση",
      "Ιός",
      "Πνευματικά δικαιώματα",
      "Σεξουαλικό περιεχόμενο",
      "Άλλο"
    ],
    "submitTxt": "Υποβολή",
    "submitTip": "Ευχαριστούμε για τα σχόλιά σας"
  },
  "nl_NL": {
    "title": "Selecteer een type feedback",
    "feedBackCates": [
      "Kan niet downloaden",
      "Kan niet installeren",
      "Oude versie",
      "Kwaadaardige lading",
      "Virus",
      "Auteursrecht",
      "Seksuele inhoud",
      "Overige"
    ],
    "submitTxt": "Verzenden",
    "submitTip": "Bedankt voor je feedback"
  },
  "ro_RO": {
    "title": "Selectați tipul de feedback",
    "feedBackCates": [
      "Descărcare imposibilă",
      "Instalare imposibilă",
      "Versiune veche",
      "Acuzații rău intenționate",
      "Virus",
      "Drepturi de autor",
      "Conținut sexual",
      "Altele"
    ],
    "submitTxt": "Trimitere",
    "submitTip": "Thanks for your feedback"
  },
  "sv_SE": {
    "title": "Välj typ av återkoppling",
    "feedBackCates": [
      "Det gick inte att ladda ned",
      "Det gick inte att installera",
      "Gammal version",
      "Skadlig avgift",
      "Virus",
      "Copyright",
      "Sexuellt innehåll",
      "Annan"
    ],
    "submitTxt": "Skicka",
    "submitTip": "Tack för din återkoppling"
  },
  "sk_SK": {
    "title": "Vyberte typ spätnej väzby",
    "feedBackCates": [
      "Nie je možné stiahnuť",
      "Nedá sa nainštalovať",
      "Stará verzia",
      "Žaloba za konanie so zlým úmyslom",
      "Virus",
      "Autorské právo",
      "Sexuálny obsah",
      "Iné"
    ],
    "submitTxt": "Odoslať",
    "submitTip": "Ďakujeme za vašu spätnú väzbu"
  },
  "pl_PL": {
    "title": "Wybierz typ opinii",
    "feedBackCates": [
      "Nie można pobrać",
      "Nie można zainstalować",
      "Stara wersja",
      "Złośliwa opłata",
      "Wirus",
      "Prawa autorskie",
      "Treści erotyczne",
      "Inne"
    ],
    "submitTxt": "Prześlij",
    "submitTip": "Dziękujemy za opinię"
  },
  "es_ES": {
    "title": "Selecciona un tipo de comentario",
    "feedBackCates": [
      "No se puede descargar",
      "No se puede instalar",
      "Versión antigua",
      "Cargo sin avisar previamente",
      "Virus",
      "Derechos de autor",
      "Contenido sexual",
      "Otro"
    ],
    "submitTxt": "Enviar",
    "submitTip": "¡Gracias por tu opinión!"
  },
  "hu_HU": {
    "title": "Válassza ki a visszajelzés típusát",
    "feedBackCates": [
      "Nem sikerült letölteni",
      "Nem sikerült telepíteni",
      "Régi verzió",
      "Kártékony töltés",
      "Virus",
      "Szerzői jog",
      "Szexuális tartalom",
      "Egyéb"
    ],
    "submitTxt": "Beküldés",
    "submitTip": "Köszönjük visszajelzését!"
  },
  "sl_SI": {
    "title": "Izberite vrsto povratnih informacij",
    "feedBackCates": [
      "Prenos trenutno ni mogoč",
      "Namestitev trenutno ni mogoča",
      "Stara različica",
      "Zlonamerna obtožba",
      "Virus",
      "Avtorske pravice",
      "S spolnostjo povezana vsebina",
      "Drugo"
    ],
    "submitTxt": "Pošlji",
    "submitTip": "Hvala za vaše povratne informacije"
  },
  "bg_BG": {
    "title": "Моля, изберете тип обратна връзка!",
    "feedBackCates": [
      "Неуспешно изтегляне",
      "Неуспешно инсталиране",
      "Стара версия",
      "Злонамерена промяна",
      "Вирус",
      "Авторски права",
      "Сексуално съдържание",
      "Други"
    ],
    "submitTxt": "Изпращане",
    "submitTip": "Благодарим ви за обратната връзка"
  },
  "et_EE": {
    "title": "Valige tagasiside tüüp",
    "feedBackCates": [
      "Ei saa alla laadida",
      "Ei saa installida",
      "Vana versioon",
      "Pahatahtlik süüdistus",
      "Viirus",
      "Autoriõigus",
      "Seksuaalne sisu",
      "Muu"
    ],
    "submitTxt": "Esita",
    "submitTip": "Aitäh tagasiside eest"
  },
  "lv_LV": {
    "title": "Atlasiet atsauksmju veidu",
    "feedBackCates": [
      "Nevar lejupielādēt",
      "Nevar instalēt",
      "Vecā versija",
      "Ļaunprātīga uzlāde",
      "Vīruss",
      "Autortiesības",
      "Seksuāls saturs",
      "Citi"
    ],
    "submitTxt": "Iesniegt",
    "submitTip": "Paldies par atsauksmi"
  },
  "lt_LT": {
    "title": "Pasirinkite atsiliepimo tipą!",
    "feedBackCates": [
      "Atsisiųsti negalima",
      "Diegti negalima",
      "Sena versija",
      "Kenkėjiškas mokestis",
      "Virusas",
      "Autorių teisės",
      "Seksualinio pobūdžio turinys",
      "Kita"
    ],
    "submitTxt": "Pateikti",
    "submitTip": "Dėkojame už atsiliepimą"
  },
  "hr_HR": {
    "title": "Odaberite vrstu povratnih informacija",
    "feedBackCates": [
      "Preuzimanje nije moguće",
      "Instaliranje nije moguće",
      "Stara verzija",
      "Zlonamjerna naplata",
      "Virus",
      "Autorsko pravo",
      "Seksualni sadržaj",
      "Ostalo"
    ],
    "submitTxt": "Pošalji",
    "submitTip": "Zahvaljujemo na povratnim informacijama"
  },
  "da_DK": {
    "title": "Vælg en feedbacktype",
    "feedBackCates": [
      "Kan ikke downloade",
      "Kan ikke installere",
      "Gammel version",
      "Svigagtig opkrævning",
      "Virus",
      "Copyright",
      "Seksuelt indhold",
      "Andet"
    ],
    "submitTxt": "Send",
    "submitTip": "Tak for din feedback"
  },
  "nb_NO": {
    "title": "Velg en tilbakemeldingstype",
    "feedBackCates": [
      "Kan ikke laste ned",
      "Kan ikke installere",
      "Gammel versjon",
      "Skadelig lading",
      "Virus",
      "Opphavsrett",
      "Seksuelt innhold",
      "Annet"
    ],
    "submitTxt": "Send inn",
    "submitTip": "Takk for tilbakemeldingen din"
  },
  "fi_FI": {
    "title": "Valitse palautteen tyyppi",
    "feedBackCates": [
      "Ei voi ladata",
      "Ei voi asentaa",
      "Vanha versio",
      "Aiheton laskutus",
      "Virus",
      "Tekijänoikeus",
      "Seksuaalinen sisältö",
      "Muut"
    ],
    "submitTxt": "Lähetä",
    "submitTip": "Kiitos palautteestasi"
  },
  "is_IS": {
    "title": "Veldu tegund endurgjafar",
    "feedBackCates": [
      "Tókst ekki að sækja",
      "Tókst ekki að setja upp",
      "Gömul útgáfa",
      "Óheimil gjaldfærsla",
      "Vírus",
      "Höfundarréttur",
      "Kynlífsefni",
      "Annað"
    ],
    "submitTxt": "Senda inn",
    "submitTip": "Takk fyrir endurgjöfina"
  },
  "lb_LU": {
    "title": "Wiel wgl. e Feedbacktyp aus",
    "feedBackCates": [
      "Erofluede feelgeschloen",
      "Installatioun feelgeschloen",
      "Al Versioun",
      "Béiswëlleg Belaaschtung",
      "Virus",
      "Copyright",
      "Sexuellen Inhalt",
      "Aner"
    ],
    "submitTxt": "Ofschécken",
    "submitTip": "Merci fir däi Feedback"
  }
}